module.exports = __webpack_public_path__ + "static/baked_seasonal_cookie-b893f918c73e802b30b49924b6173143.jpg";